<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Root'
})
</script>

<style lang="scss">

html, body {
  width: 100%;
  margin: 0px;
  padding: 0px;
}

#app {
  font-family: PingFangTC, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #7c9888;
  padding-bottom: 1px;
}
</style>
